'use client';

import { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';


export default function ProcessSectionAnimator() {

  const [lls, setLls] = useState([]);
  const [steps, setSteps] = useState([]);
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  useEffect(() => {
    const steps = Array.from(
      document.querySelectorAll('.process-step')
    );
    if (steps.length === 0) {
      return;
    }
    setSteps(steps);

    import('react-leader-line').then(({ default: LeaderLine }) => {
      const llsT = [];
      for (let i = 0; i <= steps.length - 2; i++) {
        llsT.push(new LeaderLine(steps[i], steps[i + 1], {
          startPlug: 'disc',
          endPlug: 'arrow1',
          endSocket: 'top',
          hide: true,
          color: '#ffffff',
          size: 4
        }));
      }
      setLls(llsT);
    });
  }, []);

  useEffect(() => {
    if (lls.length === 0 || lls.length !== (steps.length - 1)) return;

    const section = document.getElementById('jak-pracujeme');
    if (!section) {
      return;
    }

    let sectionTop = section.offsetTop;
    let stepHeight = section.offsetHeight / steps.length;

    const recomputeMetrics = () => {
      sectionTop = section.offsetTop;
      stepHeight = section.offsetHeight / steps.length;
    };

    window.addEventListener('resize', recomputeMetrics, { passive: true });

    let ticking = false;

    const onScroll = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset;
        const active = Math.max(
          Math.floor((scrollTop - sectionTop + 650) / stepHeight),
          0
        );

        // if (!isMobile) {
          lls.forEach((ll, i) => {
            if (active - 1 >= i) {
              ll.show('draw');
            } else {
              ll.hide('draw');
            }
          });
        // }

        steps.forEach((step, i) => {
          const shouldBeActive = active === i;
          if ((step.dataset.active === 'true') !== shouldBeActive) {
            step.dataset.active = shouldBeActive ? 'true' : 'false';
          }
        });

        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', recomputeMetrics);

      lls.forEach(ll => ll.hide());
      setLls([]);
    };
  }, [lls, steps]);

  return null;
}
